/* istanbul ignore file */

export const FILTER_LIST_RESET = 'Reset all';

export const FILTER_CONTROLS_CLOSE = 'Close';

export const FILTER_MODAL_HEADING = 'Filter & Sort';
